import { render, staticRenderFns } from "./InMorgue.vue?vue&type=template&id=7c00e7f6&"
import script from "./InMorgue.vue?vue&type=script&lang=js&"
export * from "./InMorgue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports